import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface ISuitTypeProperties {
  acao_id: number | null;
  acao_descricao: string;
}

const SuitType: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptySuitType = {
    acao_id: null,
    acao_descricao: '',
  };

  const [suitTypes, setSuitTypes] = useState<ISuitTypeProperties[]>([]);
  const [suitType, setSuitType] = useState(emptySuitType);
  const [deleteSuitType, setDeleteSuitTypeDialog] = useState(false);
  const [deleteSuitTypesDialog, setDeleteSuitTypesDialog] = useState(false);
  const [selectedSuitTypes, setSelectedSuitTypes] = useState<ISuitTypeProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('lawsuits/suittypes/show/all');
      setSuitTypes(response.data);
    })();
  }, []);

  const columns = [
    {
      field: 'acao_id', header: 'Código', sortable: true,
    },
    { field: 'acao_descricao', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/suittype/create');
  };

  const hidedeleteSuitType = () => {
    setDeleteSuitTypeDialog(false);
  };

  const hidedeleteSuitTypesDialog = () => {
    setDeleteSuitTypesDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editSuitType = (rowData:any) => {
    history.push(`/lawsuit/suittype/edit/${rowData.acao_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteSuitType = (suitType: React.SetStateAction<{
    acao_id: null; acao_descricao: string;
  }>) => {
    setSuitType(suitType);
    setDeleteSuitTypeDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/suittypes/delete/${suitType.acao_id}`);

    setDeleteSuitTypeDialog(false);

    const updatedRecords = suitTypes
      .filter((val) => val.acao_id !== suitType.acao_id);
    setSuitTypes(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editSuitType(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteSuitType(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteSuitTypeFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteSuitType} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteSuitTypesDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteSuitTypesDialog} />
      {/* <Button label="Sim" icon="pi pi-check" className="p-button-text"
      onClick={deleteselectedSuitTypes} /> */}
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Tipo de Ações</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-suittypes table"
            id="table-suittypes"
            ref={dt}
            value={suitTypes}
            editMode="row"
            dataKey="acao_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedSuitTypes}
            onSelectionChange={(e) => {
              const selSuitTypes = e.value as ISuitTypeProperties[];
              setSelectedSuitTypes(selSuitTypes);
            }}
            onRowDoubleClick={(e) => editSuitType(e.data)}
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} /> */}
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteSuitType} style={{ width: '450px' }} header="Confirmação" modal footer={deleteSuitTypeFooter} onHide={hidedeleteSuitType}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {suitType && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{suitType.acao_descricao}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteSuitTypesDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteSuitTypesDialogFooter} onHide={hidedeleteSuitTypesDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {suitType
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default SuitType;
